// import { readJson } from '../../services/fileOps'
// import Marker from './marker'
import {BasicManagedFile, tryGetAttr} from './basicManagedFile'
import {QS, SCH_GEN, SCH_INSP} from '../Data/typeDirs'
import { traverseSchema, hasOpt } from '../Services/conman'
import {genId} from '../utils'
import update from 'immutability-helper'
// import merge from 'deepmerge'

export default class QuickSelect extends BasicManagedFile {


  constructor(args){
    super(args)
    this.ext = QuickSelect.getExt()
    this.typeDir = QuickSelect.getTypeDir()
  }

  static async initDefault(ds, mainSchemaName = `${SCH_INSP}$$${'LCS Schema'}`, source={}){
    const faveGenericSchema = `${SCH_GEN}$$${'faves'}`
    const rawQuickSelect = QuickSelect.initialize([faveGenericSchema], [mainSchemaName], source)
    const newQuickSelect = new QuickSelect({content: rawQuickSelect})
    // console.log('hydrated qs', newQuickSelect)
    return newQuickSelect
  }

  static initialize(qsSchema = [], mainSchema = [], mainSource = {}){
    // console.log('quickSelect init w schema', qsSchema)
    return {
      'quickSelectInfo': {
        schema: qsSchema,
        tree: {},
        source: {
          main: {
            controls: [],
            favesGroups: []
          }
        }
      },
      'quickSelectData': {
        schema: mainSchema,
        source: mainSource,
        tree: {}
      }
    }
  }

  static getTypeDir(){
    return QS
  }

  static getExt(){
    return 'qs.json'
  }

  static tryGetAttr(attr, cb){
    return tryGetAttr(attr, cb)
  }

  static treeChange(conMan){
    return function(blockIdx, tree, ctrl){
      // let data = conMan.current.getData(false)
      if( blockIdx === 'quickSelectInfo' ){
        if( ctrl.name === 'curFavesList') {
          // let tree = data
        }
      }

    }
  }

  static sourceChange(conMan){
    // console.log('returning sourceChange fn')
    return async function(block, source, controlName, newSource, changedAddr){
      if( block === 'quickSelectInfo' ){
        let data = conMan.current.getData(false)
        // console.log('got data', data)
        data.quickSelectInfo.source = source
        return data
      }
    }
  }

  getAllGroups(){
    const ownData = this.content.getData(false)
    const ownGroups = ownData['quickSelectInfo'].source.main.favesGroups
    return ownGroups
  }

  getGroup(groupName){
    // console.log('getting group', this)
    const ownGroups = this.getAllGroups()
    console.log(ownGroups, groupName)
    const [existing] = ownGroups.filter(elm => elm._name === groupName )
    return existing
  }

  addGroup(groupName){
    const thisGroup = this.getGroup(groupName)
    if( !thisGroup ) {
      const newGroup = {
        _name: groupName,
        favesList: []
      }
      this.content.content.quickSelectInfo.source.main.favesGroups.push(newGroup)
      return newGroup
    }
    return thisGroup
  }

  getQuickSelectItem(name, groupName){
    // console.log(`looking for ${name} in ${groupName}`)
    // const ownData = this.content.getData(false)
    // console.log('my data', ownData)
    const group = this.getGroup(groupName)
    if( !group ) return null
    // console.log('found group', group)
    const [quickSelectItem] = group.favesList.filter(elm => elm._name === name)
    if( quickSelectItem ) {
      const faveId = quickSelectItem['!faveId']
      // console.log('found quickSelectItem', quickSelectItem)

      if( faveId ) {
        // console.log(this.content.content)
        quickSelectItem['_tree'] = this.content.content[faveId].tree

      }
    }
    return quickSelectItem
  }


  addQuickSelectItem(tree, name, groupName){
    const thisGroup = this.addGroup(groupName)
    const thisSelect = this.getQuickSelectItem(name, groupName)
    // if( thisSelect ) throw new Error(`quickSelect: Can't add member ${name} of ${groupName}: element exists`)
    const faveId = `_${genId()}`
    let newQuickSelectItem = thisSelect || {
      _name: name,
    }
    newQuickSelectItem['!faveId'] = faveId
    this.content.content[faveId] = {
      schema: [],
      source: {},
      tree
    }
    thisGroup.favesList.push(newQuickSelectItem)
    return newQuickSelectItem
  }

  addQuickSelectItemFromConRef(conRef){
    const allData = conRef.current.getData(false)
    const {quickSelectInfo, quickSelectData} = allData
    const {selectFavesList, curFavesGroup, curFavesList} = quickSelectInfo.tree

    const reqControls = selectFavesList.content.map(elm => elm._name)
    // console.log('req controls', reqControls)
    let {tree} = quickSelectData
    const killTheseControls = Object.keys(tree).filter(prop => !reqControls.includes(prop))

    tree = update(tree, {'$unset': killTheseControls})
    // console.log('clean tree', tree)
    const myGroup = curFavesGroup.content[0]._name
    const myName = curFavesList.content[0]._name
    for (const prop in tree){
      tree = update(tree, {[prop]: {
        '$set': {content: tree[prop].content}
      }})
    }
    this.addQuickSelectItem(tree, myName, myGroup)
    return this.getQuickSelectItem(myName, myGroup)
    // console.log(this)
  }

  // When we want to populate this quickSelect from a list of chosen templates
  async populateFromTemplates(dataSource, selectedTemplates){
    // console.log('populating from', selectedTemplates)
    let allRequired = []
    for( const template of selectedTemplates ){
      allRequired.push(await dataSource[QS].getTyped({_id: template._name}))
    }
    // console.log('toggle quick', allRequired)
    let trees = {}
    let rawSources = allRequired.map(elm => {
      Object.keys(elm.content.content).forEach(key => {
        if( key[0] === '_' ) {
          trees[key] = elm.content.content[key]
        }
      })
      return elm.content.content.quickSelectInfo.source
    })
    // console.log('now have sources to merge', rawSources)
    let mergedSource = rawSources[0]
    if( rawSources.length > 1 ){
      for( let requiredQsIndex = 1; requiredQsIndex < rawSources.length; requiredQsIndex++ ){
        let nextSource = rawSources[requiredQsIndex]
        // mergedSource = merge(mergedSource, nextSource, {
        //   arrayMerge: (target, source, options) => {
        //     let names = {}
        //     target.forEach(elm => names[elm._name] = elm)
        //     source.forEach(elm => {
        //       if( names[elm._name] ){
        //         names[elm._name] = merge(names[elm._name], elm, options)
        //       } else {
        //         names[elm._name] = elm
        //       }
        //     })
        //     return Object.keys(names).map(name => names[name])
        //   }
        // })
      }
    }
    if( mergedSource ){
      // console.log('generating merged source content', quickSelect)
      // console.log('assign', mergedSource)
      // console.log('to', quickSelect.content.content.quickSelectInfo.source)
      this.content.content.quickSelectInfo.source = mergedSource
      // console.log('content.content', quickSelect.content.content)
      this.content.content = {...this.content.content, ...trees}
      // console.log('and again content', quickSelect.content.content)


    }
    return this
  }



  async hydrate(dataSource){
    await super.hydrate(dataSource)
    // console.log('qs content', this.content)
    const ownContent = this.content.getData(false)
    // console.log('qs hydrate', ownContent)
    const allControls = []
    // console.log('scanning schema', targetSchema)
    if( ownContent && ownContent.quickSelectData && ownContent.quickSelectData.schema ) {
      const targetSchema = ownContent.quickSelectData.schema

      traverseSchema(targetSchema, {}, {}, control => {
        let {name, label, type, options, schIdx} = control
        options = options || []
        let hid = hasOpt('hidden', options)
        let unres = hasOpt('unrepresented', options)
        let offs = hasOpt('offscreen', options)
        if ( type !== 'page' && !hid && !unres && !offs ) {
          allControls.push({_name: name, _mask: label, schIdx})
        }
      })
      this.content.content.quickSelectInfo.source.main.controls = allControls

    }

    // console.log('quickselect content', this.content)
    // console.log('hydrated quickSelect', this)
    return this
  }


}
